var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app__container"},[_c('Header',{on:{"openPopup":_vm.openPopup}}),_vm._v(" "),_c(_vm.getActiveScreen,{tag:"component"}),_vm._v(" "),(_vm.show_points)?_c('Points',{on:{"closePopup":_vm.closePopup}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }